module.exports = __webpack_public_path__ + "static/media/person-on-a-bridge-near-a-lake-747964.a6afe317.jpg";